import React, { Component, Fragment } from 'react'
import { NavLink } from "react-router-dom";
import { IsAuthorize } from '../../../../shared/authorization/check-access';
import { Role } from '../../../../shared/authorization/enums';

interface IProps {
    id: number,
    url: string
}
export class ExtractionEnginesTabs extends Component<IProps> {
    render() {
        return (
            <Fragment>
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {IsAuthorize([Role.Dev]) && <li className="nav-item">
                        <NavLink to={"/extraction-engine/extraction-engine-form/" + this.props.id} className={this.props.url == "/extraction-engine/extraction-engine-form/" ? "nav-link active" : "nav-link"} id="edit-tab" data-toggle="tab" href="#edit" role="tab"
                            aria-controls="edit" aria-selected={this.props.url == "/extraction-engine/extraction-engine-form/" ? "true" : "false"}><i className="far fa-edit"></i>&nbsp;Edit</NavLink>
                    </li>}
                    {/* {IsAuthorize([Role.Dev]) &&  <li className="nav-item">
                        <NavLink to={"/extraction-engine/delete/" + this.props.id} className={this.props.url == "/extraction-engine/delete/" ? "nav-link active" : "nav-link"} id="show-tab" data-toggle="tab" href="#delete" role="tab"
                            aria-controls="delete" aria-selected={this.props.url == "/extraction-engine/delete/" ? "true" : "false"}><i className="far fa-trash-alt"></i>&nbsp;Delete</NavLink>
                    </li>} */}
                    {IsAuthorize([Role.Sales, Role.Dev,Role.Sales,Role.AM, Role.Support ,Role.Manager]) && <li className="nav-item">
                        <NavLink to={"/extraction-engine/detail/" + this.props.id} className={this.props.url == "/extraction-engine/detail/" ? "nav-link active" : "nav-link"} id="show-tab" data-toggle="tab" href="#show" role="tab"
                            aria-controls="show" aria-selected={this.props.url == "/extraction-engine/detail/" ? "true" : "false"}><i className="fas fa-info-circle"></i>&nbsp;Show</NavLink>
                    </li>}
                </ul>
                <br />
            </Fragment>
        )
    }
}
